//@flow
import React, { Component } from 'react';
import {
  LgDesktop,
  Desktop,
  Default,
  SmDesktop
} from '../../../../components/Responsive';
import { ModelListTh } from '../../../../components/ModelListStyles';
import Switch from '../../../../components/Switch';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  orderBy: {
    createdAt: number => void,
    merchantName: number => void,
    processingVolume: number => void,
    transactionFee: number => void,
    commission: number => void
  },
  orderState: {
    createdAt: number,
    merchantName: number,
    processingVolume: number,
    transactionFee: number,
    commission: number
  }
};

export default class DirectMerchantTableHeader extends Component<Props> {
  handleCreatedAtClick = (orderState: number) => {
    this.props.orderBy.createdAt(orderState);
  };

  handleMerchantNameClick = (orderState: number) => {
    this.props.orderBy.merchantName(orderState);
  };

  handleProcessingVolClick = (orderState: number) => {
    this.props.orderBy.processingVolume(orderState);
  };

  handleTransactionFeeClick = (orderState: number) => {
    this.props.orderBy.transactionFee(orderState);
  };

  handleCommissionClick = (orderState: number) => {
    this.props.orderBy.commission(orderState);
  };

  renderTh = (
    text: string,
    type: string,
    cb: Function,
    right: boolean = true
  ) => (
    <ModelListTh right={right}>
      <Switch
        text={text}
        orderState={this.props.orderState[type]}
        handleClick={orderState => cb(orderState)}
      />
    </ModelListTh>
  );

  render() {
    return (
      <DefaultModelRowTr>
        <Desktop>
          {this.renderTh('Date', 'createdAt', this.handleCreatedAtClick, false)}
        </Desktop>
        <LgDesktop>
          <ModelListTh>Transaction ID</ModelListTh>
        </LgDesktop>
        {this.renderTh(
          'Merchants',
          'merchantName',
          this.handleMerchantNameClick,
          false
        )}
        <Default>
          {this.renderTh(
            'Processing Vol.',
            'processingVolume',
            this.handleProcessingVolClick
          )}
        </Default>
        <SmDesktop>
          {this.renderTh(
            'Trans. Fee',
            'transactionFee',
            this.handleTransactionFeeClick
          )}
        </SmDesktop>
        <LgDesktop>
          {this.renderTh(
            'Transaction Fee',
            'transactionFee',
            this.handleTransactionFeeClick
          )}
        </LgDesktop>
        <ModelListTh right>
          <Switch
            text={'Commission'}
            orderState={this.props.orderState.commission}
            handleClick={orderState => this.handleCommissionClick(orderState)}
          />
        </ModelListTh>
      </DefaultModelRowTr>
    );
  }
}
